<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="质量判责待办"
      class="processException-edit"
      width="1200px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="processException"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="质量判责" name="first">
          <el-form-item label="质量判责结果" prop="judgmentResult">
            <el-input v-model="processException.judgmentResult" type="textarea"/>
          </el-form-item>
          <el-row/>
          <el-row>
            <el-col :span="8">
              <el-form-item label="责任部门" prop="responsibleDepartment">
                <el-input v-model="processException.responsibleDepartment" readonly placeholder="请选择责任部门">
                  <el-button slot="append" @click="$refs.departmentSelect.open()">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="责任部门接口人">
                <el-input v-model="processException.responsibleName" readonly placeholder="请选择责任部门接口人">
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsible.open()"/>
                </el-input>
                <user-select ref="selectResponsible" @select="selectResponsible"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="processException.supplierName" readonly placeholder="请选择供应商">
                  <el-button slot="append" @click="$refs.supplierSelect.open()">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="基础信息" name="second">
          <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">系统编号:</td>
              <td>{{processException.billNo}}</td>
              <td class="tableLabel">开单人:</td>
              <td>{{processException.creatorName}}</td>
              <td class="tableLabel">登记日期:</td>
              <td>{{processException.createTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">反馈部门:</td>
              <td>{{processException.feedbackDepart}}</td>
              <td class="tableLabel">反馈人:</td>
              <td>{{processException.feedbackPerson}}</td>
              <td class="tableLabel">出厂编号:</td>
              <td>{{processException.factoryNo}}</td>
            </tr>
            <tr>
              <td class="tableLabel">客户名称:</td>
              <td>{{processException.customerName}}</td>
              <td class="tableLabel">物料号:</td>
              <td>{{processException.materialNo}}</td>
              <td class="tableLabel">物料描述:</td>
              <td>{{processException.materialName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">当批总数:</td>
              <td>{{processException.batchNum}}</td>
              <td class="tableLabel">不良数量:</td>
              <td>{{processException.badNum}}</td>
              <td class="tableLabel">误工工时:</td>
              <td>{{processException.workTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">一体机/板卡序列号:</td>
              <td colspan="5">{{processException.serialNo}}</td>
            </tr>
          </table>

          <h1 class="mainTitle" style="font-size: 16px;text-align: left;">问题描述</h1>
          <div class="title"/>
          <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">基准:</td>
              <td>{{processException.standards}}</td>
            </tr>
            <tr>
              <td class="tableLabel">实际:</td>
              <td>{{processException.problemDesc}}</td>
            </tr>
            <tr>
              <td class="tableLabel">备注:</td>
              <td>{{processException.note}}</td>
            </tr>
            <tr>
              <td class="tableLabel">是否需要对当前问题处理:</td>
              <td>{{processException.isHandle ? "是" : "否"}}</td>
            </tr>
            <tr v-if="processException.isHandle">
              <td class="tableLabel">处理部门接口人:</td>
              <td>{{processException.handleName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">质量部接口人:</td>
              <td>{{processException.qualityDirecterName}}</td>
            </tr>
          </table>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <el-table :data="processException.accessories">
            <el-table-column type="index" label="序号" width="50" align="center"/>
            <el-table-column label="附件名称" align="left" prop="fileName"/>
            <el-table-column label="备注" align="left" prop="note"/>
            <el-table-column label="操作" align="center" width="90">
              <template slot-scope="scope">
                <el-button type="primary" @click="downloadFile(scope.row.filePath)">查看附件</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="处理部门处理" name="third">
          <el-row>
            <el-col :span="8">
              <el-form-item disabled label="不合格品处理方式">
                <el-select v-model="processException.processMode" disabled>
                  <el-option value="维修返工" label="维修返工"/>
                  <el-option value="退货" label="退货"/>
                  <el-option value="挑选" label="挑选"/>
                  <el-option value="让步接收(特批)" label="让步接收(特批)"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button type="danger" :loading="rejectLoading" @click="handleReject">驳回</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">提交</el-button>
      <!--      <el-button v-if="processException.isHandle" type="warning" :loading="submitLoading" @click="handleSubmit">提交</el-button>-->
    </div>
    <material-select ref="materialSelect" @select="addMaterial"/>
    <customer-select ref="customerSelect" @select="customerAdd"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <department-select ref="departmentSelect" @select="departmentSelect"/>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import MaterialSelect from "@/views/information/MaterialManagement/MaterialManagementSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierManageSelect";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  export default {
    name:"QualityJudgmentEdit",
    components:{MaterialSelect,CustomerSelect,SupplierSelect,DepartmentSelect,UserSelect},
    data() {
      return {
        dialogVisible:false,
        contentLoading:false,
        uploadLoading:false,
        saveLoading:false,
        rejectLoading:false,
        submitLoading:false,
        activeName:"first",
        processException:{
          pkid:0,
          billNo:"",
          createTime:"",
          customerName:"",
          factoryNo:"",
          department:loginUtil.getDepartmentName(),
          customerId:"",
          qualityDirecterId:"",
          qualityDirecterName:"",
          handleId:"",
          processMode:"",
          problemDesc:"",
          isHandle:false,
          serialNo:"",
          handleName:"",
          supplierName:"",
          responsibleDepartment:"",
          judgmentResult:"",
          creatorName:loginUtil.getName(),
          processExceptionMaterialVOS:[],
          accessories:[],
        },
        ruleValidate: {
          // responsibleDepartment: {required: true, message: "不能为空", trigger: "blur"},
          // judgmentResult: {required: true, message: "不能为空", trigger: "blur"},
          // supplierName: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    mounted() {
    },
    methods:{
      open(id) {
        console.log(id);
        this.dialogVisible = true;
        this.processException.pkid = id;
        if(id>0) {
          this.getData();
        }else {
          this.getSelectNo();
          this.getFormatDate(new Date());
        }
      },
      getData() {
        this.$http.get("basic",`processExceptions/${this.processException.pkid}`).then((res)=>{
          console.log(res);
          this.processException = res;
        });
      },
      getSelectNo() {
        this.$http.get("basic","processExceptions/selectNo").then((res)=>{
          this.processException.billNo = res;
        });
      },
      downloadFile(path) {
        let a = document.createElement("a");
        a.href = "https://emes.stepelectric.com" + path;
        a.target = "_blank";
        a.download = path;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.processException.accessories.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.processException.accessories.splice(index, 1);
      },
      oneDelete(index) {
        this.processException.processExceptionMaterialVOS.splice(index,1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "https://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },

      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        console.log(date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds);
        this.processException.createTime = date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },

      customerAdd(row) {
        console.log(row);
        this.processException.customerName = row.customerName;
        this.processException.customerId = row.customerID;
      },

      selectHandle(row) {
        this.processException.handleId = row.systemUserID;
        this.processException.handleName = row.employeeName;
      },

      selectResponsible(row) {
        this.processException.responsibleId = row.systemUserID;
        this.processException.responsibleName = row.employeeName;
      },

      selectQualityDirecter(row) {
        this.processException.qualityDirecterId = row.systemUserID;
        this.processException.qualityDirecterName = row.employeeName;
      },

      addMaterial(row) {
        console.log(row);
        let material = {
          materialId: row.id,
          materialNo: row.no,
          materialName: row.name,
          badNum: 1,
        };
        this.processException.processExceptionMaterialVOS.push(material);
      },

      supplierSelect(row) {
        console.log("供应",row);
        this.processException.supplierId = row.pkid;
        this.processException.supplierName = row.name;
      },
      getCustomerName() {
        if (this.processException.factoryNo) {
          console.log(this.processException.factoryNo);
          let params = {
            pcNo: this.processException.factoryNo,
          };
          this.$http.get("basic","sd/so/selectByPcNo",params).then((res)=>{
            console.log(res);
            this.processException.customerName = res.data.customerName;
            this.processException.customerId = res.data.customerID;
          });
        }
      },
      departmentSelect(row) {
        console.log("部门",row);
        this.processException.responsibleDepartment = row.departmentName;
      },

      deleteRow(index) {
        this.processException.processExceptionMaterialVOS.splice(index,1);
      },

      handleReject() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.rejectLoading = true;
            this.$http.get("basic", "processExceptions/qualityBack/" + this.processException.pkid).then(() => {
              this.$emit("save-success");
              this.$message.success("驳回成功");
              this.dialogVisible = false;
            }).finally(() => {
              this.rejectLoading = false;
            });
          }
        });
      },

      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http.put("basic","processExceptions/qualityJudgmentEdit",this.processException).then((res)=>{
              this.$emit("save-success");
              this.$message.success("保存成功");
              this.saveLoading = false;
              this.dialogVisible = false;
            }).catch(() => {
              this.saveLoading = false;
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.processException-edit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.processException-edit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.processException-edit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.processException-edit .el-divider--horizontal {
  margin: 10px 0;
}

.processException-edit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.ProcessExceptionTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProcessExceptionTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.ProcessExceptionTable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  border-left: none;
  border-bottom: none;
}

.tableLabel {
  width: 15%;
  text-align: right;
  background-color: #d1e6f5 !important;
}
</style>